/* eslint-disable @typescript-eslint/restrict-plus-operands */
import {
  type Action, type AsyncStateObject, type GoalListData
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, ENGAGEMENT_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<GoalListData[]> = {
  data: [],
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const getGoalsByEngagementByIdReducer = (state = INITIAL_STATE, action: Action<GoalListData[]>) => {
  switch (action.type) {
    case ENGAGEMENT_ACTIONS.GET_GOALS_BY_ENGAGEMENT_ID + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case ENGAGEMENT_ACTIONS.GET_GOALS_BY_ENGAGEMENT_ID + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case ENGAGEMENT_ACTIONS.GET_GOALS_BY_ENGAGEMENT_ID + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case ENGAGEMENT_ACTIONS.GET_GOALS_BY_ENGAGEMENT_ID + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default getGoalsByEngagementByIdReducer
